import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as EstadosCooperativaService from '../../services/estadosCooperativas.service';

import type { RootState } from '../store';

type Entity = Awaited<ReturnType<typeof EstadosCooperativaService.getEstadosCooperativas>>[number];

export const fetchEstadosCooperativas = createAsyncThunk<Entity[]>(
  'estadosCooperativas/fetch',
  (_params, api) => {
    const { estadosCooperativas } = api.getState() as RootState;
    if (estadosCooperativas.entities.length) return Promise.resolve(estadosCooperativas.entities);
    return EstadosCooperativaService.getEstadosCooperativas();
  }
);

interface EstadosCooperativasState {
  loading: boolean;
  entities: Entity[];
}

const initialState: EstadosCooperativasState = { loading: false, entities: [] };

const estadosCooperativasSlice = createSlice({
  name: 'estados_cooperativas',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchEstadosCooperativas.fulfilled, (state, action) => {
      state.entities = action.payload;
      state.loading = false;
    });

    builder.addCase(fetchEstadosCooperativas.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(fetchEstadosCooperativas.rejected, (state) => {
      state.loading = false;
    });
  }
});

export const estadosCooperativasActions = {
  ...estadosCooperativasSlice.actions,
  fetchEstadosCooperativas
};

export default estadosCooperativasSlice.reducer;
